import { cache } from 'react'
import { jsonGetFetcher } from '@/src/fetchers'

export const getUser = cache(async (token) => {
  let url = `${process.env.API}/users/me`
  return jsonGetFetcher([url, token])
})
